import React, { useEffect, useState } from "react";
import { Library, ExternalLink } from "lucide-react";
import { getSourcesRegistry } from "@/lib/api";
import { T } from "@/context/LanguageContext";

/**
 * Reusable authoritative Sources Registry — the public-domain federal sources
 * (Census, LOC, NCES, etc.) recovered from the legacy USAStates.com portal and
 * used by USAPulse to independently re-verify facts. Purely informational.
 */
export function SourcesRegistry() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    getSourcesRegistry().then((d) => { if (alive) setData(d); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!data?.federal?.length) return null;

  return (
    <section className="mx-auto max-w-[1500px] px-4 pb-10" data-testid="sources-registry">
      <div className="rounded-2xl border border-navy/15 bg-white p-5">
        <div className="mb-3 flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-navy text-white">
            <Library className="h-5 w-5" />
          </span>
          <div>
            <h3 className="font-display text-xl font-black text-navy"><T>Authoritative Sources</T></h3>
            <p className="text-[11px] text-muted-foreground"><T>{data.note}</T></p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3 lg:grid-cols-4" data-testid="sources-grid">
          {data.federal.map((s) => (
            <a
              key={s.label}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between gap-2 rounded-lg border border-border bg-parchment/40 px-3 py-2.5 text-sm font-medium text-navy transition-colors hover:border-navy/30 hover:bg-parchment"
              data-testid={`source-lead-${s.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              <span className="truncate">{s.label}</span>
              <ExternalLink className="h-3.5 w-3.5 shrink-0 opacity-50 group-hover:opacity-100" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SourcesRegistry;
